export class NationalityModel {

    NationalityCode: string;

    NationalityName: string;

    NationalityGroupName: string;

    ModifiedDate: string;

    ModifiedUser: string;

    NationalityGroupCode: string;

    CountryCode: string;

    ActiveFlag: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/Registration/NationalityModel.ts